import type { ClientChangePersonFeatureEnabledRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useSharedFeatureEventsApi } from '@/features/api/hooks/shared-feature/useSharedFeatureEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useChangePersonFeatureEnabled = () => {
  const queryClient = useQueryClient();
  const api = useSharedFeatureEventsApi();

  return useApiMutation({
    mutationFn: (
      clientChangePersonFeatureEnabledRequest: ClientChangePersonFeatureEnabledRequest
    ) =>
      api.onChangePersonFeatureEnabledRequest({
        clientChangePersonFeatureEnabledRequest
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API_CACHE_KEYS.FEATURES] });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.POST_CREATION_OPTIONS]
      });
    }
  });
};
